import React from 'react';
import InternalExternalLink from '../Link';
import Image from '../Image';

// Interface
import { buttonInterface } from '../../interfaces/button';

function Button({ data }: { data: buttonInterface }) {
  const { color, link, size, variation, elevation, trailingIcon, leadingIcon } = data;

  return (
    <InternalExternalLink
      className={`cl-button cl-button--${size} cl-button--${color} cl-button--${variation} cl-button--${elevation}`}
      link={link}
    >
      {leadingIcon && <Image data={leadingIcon} />}

      {link.linkName}

      {trailingIcon && <Image data={trailingIcon} />}
    </InternalExternalLink>
  );
}

export default Button;
